import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const MenuPage = () => {
  useEffect(() => {
    document.title = 'メニュー｜さかなの木';
    
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const [activeTab, setActiveTab] = useState<'food' | 'drink'>('food');

  const foodCategories = [
    {
      title: 'お通し',
      items: [
        { name: '秋田野菜の一品', price: '¥450' },
      ],
    },
    {
      title: '刺身',
      items: [
        { name: '本日の刺身', price: '¥450〜', note: '※日によって魚の種類が変わります。詳細はお店でご確認ください' },
      ],
    },
    {
      title: '秋田野菜',
      items: [
        { name: '秋田野菜', price: '¥290〜', note: '※産地直送の新鮮野菜。日によって野菜の種類が変わります' },
      ],
    },
    {
      title: 'つまみ',
      items: [
        { name: 'つまみ', price: '¥320〜', note: '※日替わりのつまみ各種。詳細はお店でご確認ください' },
      ],
    },
    {
      title: '飯',
      items: [
        { name: '本マグロ赤身とたくあんの海苔巻き寿司', price: '¥590' },
        { name: '涙巻き', price: '¥490', description: '鹿児島県産本干したくあん入り' },
        { name: '鯛胡麻茶漬け', price: '¥750' },
        { name: '魚味噌焼きおにぎり', price: '¥350' },
      ],
    },
    {
      title: 'ランチ',
      time: '11:30〜14:00（LO.13:30）',
      items: [
        { name: 'さかなの木豆皿ランチ', price: '¥1,600', description: '小皿で楽しむ多彩な料理。新鮮な魚介と秋田野菜を使った当店自慢のランチセット' },
        { name: '海鮮丼 〆胡麻茶漬け', price: '¥1,400', description: '新鮮な海鮮をたっぷり使った丼。最後は胡麻茶漬けでさっぱりとお楽しみいただけます' },
        { name: '宇和島鯛めし', price: '¥1,200', description: 'ご飯、真鯛、卵だし醤油、しらすと薬味、小鉢、味噌汁付き' },
      ],
    },
  ];

  const drinkCategories = [
    {
      title: '日本酒',
      items: [
        { name: '本日の日本酒', price: '¥550〜', note: '※15種類以上の厳選日本酒を季節ごとにご用意。100mlからお楽しみいただけます。日替わりで種類が変わりますので、詳しくはスタッフまでお尋ねください' },
      ],
    },
    {
      title: 'ビール',
      items: [
        { name: 'サッポロラガー', price: '¥800' },
        { name: 'アサヒ生ビールマルエフ', price: '¥800' },
        { name: 'キリン一番搾り', price: '¥800' },
        { name: 'サントリープレミアムモルツ', price: '¥800' },
        { name: 'アサヒスーパードライ', price: '¥800' },
      ],
    },
    {
      title: 'ノンアルコールビール',
      items: [
        { name: 'アサヒドライゼロ', price: '¥550' },
        { name: 'キリングリーンズフリー', price: '¥550' },
      ],
    },
    {
      title: 'サワー',
      items: [
        { name: '樽熟成ハイボール', price: '¥700' },
        { name: '生レモンサワー', price: '¥600' },
        { name: 'ジンソーダ', price: '¥600' },
        { name: '八街生姜ジンジャーサワー', price: '¥700' },
        { name: '八街ジンジャーハイボール', price: '¥750' },
        { name: '香檳烏龍ハイ', price: '¥700' },
      ],
    },
    {
      title: 'ワイン',
      items: [
        { name: 'まるき葡萄酒 甲州 G.I.山梨（白）', price: '¥3,800' },
        { name: 'まるき葡萄酒 マスカット・ベーリーA G.I.山梨（赤）', price: '¥3,800' },
        { name: 'ドメーヌ・レゾン オレンジワイン（オレンジ）', price: '¥4,000' },
      ],
    },
    {
      title: '果実酒',
      items: [
        { name: '鳥海山ヨーグルト酒', price: '¥750' },
        { name: '山形政宗 梅酒', price: '¥750' },
        { name: '梅乃宿あらごしみかん酒', price: '¥750' },
        { name: '鳳凰美田 もも酒', price: '¥750' },
      ],
    },
    {
      title: '焼酎',
      items: [
        { name: '樽熟成 青鹿毛（麦）', price: '¥550' },
        { name: '七田 吟醸酒粕焼酎（米）', price: '¥700' },
        { name: 'くじら 綾紫 黒麹（芋）', price: '¥600' },
        { name: '富乃宝山（芋）', price: '¥700' },
      ],
    },
    {
      title: 'ソフトドリンク',
      items: [
        { name: '100% リンゴジュース', price: '¥400' },
        { name: 'こだわりのグレープジュース', price: '¥400' },
        { name: '八街生姜ジンジャーエール', price: '¥550' },
        { name: '香檳烏龍茶', price: '¥500' },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e58742966538d819c30edb2b96d9974d.webp"
            alt="さかなの木 メニュー"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/30"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">MENU</h2>
              <p className="text-lg md:text-xl mt-4 text-white">メニュー</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>メニュー｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Tab Navigation */}
      <section className="sticky top-20 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex gap-4 justify-center py-6">
            <button
              onClick={() => setActiveTab('food')}
              className={`px-8 py-3 rounded-full text-base font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === 'food'
                  ? 'bg-primary text-white shadow-md'
                  : 'bg-white text-accent border-2 border-gray-300 hover:bg-gray-50'
              }`}
            >
              フードメニュー
            </button>
            <button
              onClick={() => setActiveTab('drink')}
              className={`px-8 py-3 rounded-full text-base font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeTab === 'drink'
                  ? 'bg-primary text-white shadow-md'
                  : 'bg-white text-accent border-2 border-gray-300 hover:bg-gray-50'
              }`}
            >
              ドリンクメニュー
            </button>
          </div>
        </div>
      </section>

      {/* Food Menu */}
      {activeTab === 'food' && (
        <section 
          className="py-20 relative"
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full object-cover object-center"
              src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
              alt="背景"
            />
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-5xl mx-auto">
              {/* 税込表記 */}
              <div className="text-center mb-8">
                <p className="text-sm text-[#3A3D3F] font-medium">※価格は全て税込です。</p>
              </div>
              
              <div className="space-y-12">
                {foodCategories.map((category, index) => (
                  <div key={index} className="bg-white rounded-lg shadow-md p-8 border border-gray-100">
                    <div className="mb-6">
                      <h2 className="text-2xl font-bold text-[#3A3D3F] pb-3 border-b-2 border-primary inline-block">
                        {category.title}
                      </h2>
                      {category.time && (
                        <p className="text-sm text-primary font-medium mt-2">
                          <i className="ri-time-line mr-1"></i>
                          {category.time}
                        </p>
                      )}
                    </div>
                    <div className="space-y-4">
                      {category.items.map((item, idx) => (
                        <div key={idx} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                          <div className="flex justify-between items-start gap-4 mb-2">
                            <h3 className="text-lg font-medium text-[#3A3D3F] flex-1">{item.name}</h3>
                            <p className="text-xl font-bold text-primary whitespace-nowrap">{item.price}</p>
                          </div>
                          {item.description && (
                            <p className="text-sm text-gray-600 mb-1">{item.description}</p>
                          )}
                          {item.note && (
                            <p className="text-xs text-orange-600">{item.note}</p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Drink Menu */}
      {activeTab === 'drink' && (
        <section 
          className="py-20 relative"
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full object-cover object-center"
              src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
              alt="背景"
            />
          </div>
          <div className="container mx-auto px-4 relative z-10">
            {/* 税込表記 */}
            <div className="text-center mb-8">
              <p className="text-sm text-[#3A3D3F] font-medium">※価格は全て税込です。</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
              {drinkCategories.map((category, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
                  <h3 className="text-xl font-bold text-[#3A3D3F] mb-4 pb-3 border-b-2 border-primary">
                    {category.title}
                  </h3>
                  <div className="space-y-3">
                    {category.items.map((item, idx) => (
                      <div key={idx} className="flex justify-between items-start gap-4">
                        <div className="flex-1">
                          <p className="text-[#3A3D3F] font-medium">{item.name}</p>
                          {item.note && (
                            <p className="text-xs text-orange-600 mt-1">{item.note}</p>
                          )}
                        </div>
                        <p className="text-primary font-bold whitespace-nowrap">{item.price}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Takeout Section */}
      <section className="py-20 bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-primary/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-300/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
                <i className="ri-takeaway-line text-xl text-primary"></i>
                <span className="text-sm font-bold text-primary tracking-wider">TAKEOUT</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#3A3D3F] mb-4">
                お持ち帰りで<br className="md:hidden" />さかなの木の味を
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                前日までのご予約で、新鮮な魚介を使った特製弁当をご用意いたします
              </p>
            </div>

            {/* Content Grid */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              {/* Image Card */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-primary to-orange-400 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
                <div className="relative bg-white rounded-2xl overflow-hidden shadow-xl">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/488814045f8b783dec919162c77b149d.webp"
                      alt="テイクアウト弁当"
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute top-4 right-4 px-4 py-2 bg-primary text-white rounded-full font-bold text-sm shadow-lg">
                    前日予約制
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="space-y-6">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-primary to-orange-400 rounded-xl flex-shrink-0 shadow-md">
                      <i className="ri-restaurant-2-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-[#3A3D3F] mb-2">新鮮な魚介</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        市場から直送された新鮮な魚介を使用。店内と同じクオリティでご提供します
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-orange-400 to-red-400 rounded-xl flex-shrink-0 shadow-md">
                      <i className="ri-time-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-[#3A3D3F] mb-2">前日予約でOK</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        お電話またはLINEで前日までにご予約いただければ、ご希望の時間にお渡しできます
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-400 to-pink-400 rounded-xl flex-shrink-0 shadow-md">
                      <i className="ri-home-heart-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-[#3A3D3F] mb-2">様々なシーンで</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        ご自宅でのお食事、オフィスランチ、ピクニックなど、様々なシーンでお楽しみいただけます
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="bg-white rounded-2xl p-8 md:p-10 shadow-xl">
              <h3 className="text-2xl font-bold text-[#3A3D3F] text-center mb-6">
                ご予約はこちらから
              </h3>
              <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
                {/* Phone Button */}
                <a
                  href="tel:03-6715-0369"
                  className="group relative flex flex-col items-center justify-center p-8 bg-gradient-to-br from-primary to-orange-400 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-white/0 to-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                  <div className="relative z-10 w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-phone-line text-3xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-2">電話で予約</h4>
                  <p className="text-2xl font-bold text-white mb-3 group-hover:scale-105 transition-transform duration-300">03-6715-0369</p>
                  <div className="flex items-center gap-2 text-white/90 text-sm">
                    <span>今すぐ電話する</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </a>

                {/* LINE Button */}
                <a
                  href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative flex flex-col items-center justify-center p-8 bg-gradient-to-br from-[#06C755] to-[#05B04D] rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-white/0 to-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
                  <div className="relative z-10 w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-line-fill text-3xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-2">LINEで予約</h4>
                  <p className="text-white/90 mb-3">24時間受付可能</p>
                  <div className="flex items-center gap-2 text-white text-sm font-bold">
                    <span>LINEを開く</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </a>
              </div>

              {/* Additional Info */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-calendar-check-line text-primary"></i>
                    <span>前日までのご予約</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-primary"></i>
                    <span>受取時間：11:00-21:00</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-money-yen-circle-line text-primary"></i>
                    <span>価格はお問い合わせください</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Note Section */}
      <section className="py-12 bg-beige">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-sm text-gray-600">
              ※メニューは日替わりで変更となる場合がございます。<br />
              ※詳しいメニューや本日のおすすめは、Instagramで毎日更新しております。<br />
              ※価格は全て税込表示です。
            </p>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-purple-400/20 to-pink-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-gradient-to-br from-orange-400/20 to-pink-400/20 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Left Content */}
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full text-sm font-bold mb-6">
                  <i className="ri-instagram-line text-xl"></i>
                  <span>FOLLOW US</span>
                </div>
                <h2 className="text-4xl md:text-5xl font-bold text-accent mb-4">
                  本日のメニューを<br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                    毎日更新中！
                  </span>
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  市場から仕入れた新鮮な魚介を使った本日のおすすめメニュー、季節の特別料理をInstagramで毎日お届けしています。
                </p>
                
                {/* Features */}
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex-shrink-0">
                      <i className="ri-restaurant-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-1">本日のおすすめメニュー</h3>
                      <p className="text-sm text-gray-600">新鮮な魚介を使った日替わりメニューを毎日投稿</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-orange-500 to-pink-500 rounded-lg flex-shrink-0">
                      <i className="ri-price-tag-3-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-1">限定メニュー情報</h3>
                      <p className="text-sm text-gray-600">季節限定や数量限定のメニューをいち早くお知らせ</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-500 rounded-lg flex-shrink-0">
                      <i className="ri-image-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-accent mb-1">料理の写真</h3>
                      <p className="text-sm text-gray-600">美味しそうな料理の写真で食欲をそそります</p>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <a
                  href="https://www.instagram.com/sakananoki_unoki/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer relative overflow-hidden"
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-700 via-pink-700 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  <i className="ri-instagram-line text-2xl relative z-10"></i>
                  <span className="relative z-10">@sakananoki_unoki</span>
                  <i className="ri-arrow-right-line text-xl relative z-10 group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>

              {/* Right Content - Instagram Preview */}
              <div className="relative">
                {/* Instagram Frame */}
                <div className="bg-white rounded-3xl shadow-2xl p-6 transform hover:scale-105 transition-transform">
                  <blockquote 
                    className="instagram-media" 
                    data-instgrm-permalink="https://www.instagram.com/sakananoki_unoki/?utm_source=ig_embed&amp;utm_campaign=loading" 
                    data-instgrm-version="14"
                    style={{
                      background: '#FFF',
                      border: 0,
                      borderRadius: '12px',
                      boxShadow: 'none',
                      margin: '0 auto',
                      maxWidth: '540px',
                      minWidth: '326px',
                      padding: 0,
                      width: '100%'
                    }}
                  >
                  </blockquote>
                </div>
                
                {/* Floating Elements */}
                <div className="absolute -top-6 -right-6 w-20 h-20 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl shadow-lg transform rotate-12 animate-bounce">
                  <i className="ri-heart-fill text-white text-3xl"></i>
                </div>
                <div className="absolute -bottom-4 -left-4 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-pink-500 rounded-xl shadow-lg transform -rotate-12">
                  <i className="ri-chat-smile-3-fill text-white text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MenuPage;
